import { Navigate, useLocation, useParams } from "react-router-dom";

export default function TemplateProjectRedirect() {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const location = useLocation();
  const destination = projectSlug ? `/websites/${encodeURIComponent(projectSlug)}/` : "/websites";
  return <Navigate to={`${destination}${location.search}${location.hash}`} replace />;
}
